import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import {
  Button,
  Dropdown,
  Layout,
  Menu,
  MenuProps,
  Grid,
  Radio,
  Select,
  Divider,
} from 'antd';
import {
  BankOutlined,
  BuildOutlined,
  CalendarOutlined,
  CarryOutOutlined,
  MailOutlined,
  MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
  SmileOutlined,
  SolutionOutlined,
  SwapOutlined,
  TableOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useConnection, useUser } from '../connection/connection';
import { Outlet, useNavigate } from 'react-router-dom';
import { useWebUxContext } from './WebUxContext';
import { UserAvatar } from '../common/UserAvatar';
import { useTranslation } from 'react-i18next';
import { Permission } from '../dto';
import ChangePasswordModal, {
  useChangePasswordModal,
} from '../login/ChangePasswordModal';

const { Content, Sider } = Layout;
export const WebUx: FC = () => {
  const navigate = useNavigate();
  const user = useUser();
  const connection = useConnection();
  const ctx = useWebUxContext();
  const { t, i18n } = useTranslation();
  const bp = Grid.useBreakpoint();
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const [businesses, setBusinesses] = useState<any[]>([]);
  const changePw = useChangePasswordModal();
  useEffect(() => {
    if (!user) {
      navigate('/login');
    }
    if (user?.businessId) {
      connection.get(`businesses/${user.userId}`).then((res) => {
        if (res.data.length > 0) {
          const b = res.data.map((business: any) => {
            return {
              label: business.name,
              value: business.businessId,
            };
          });
          setBusinesses(b);
        }
      });
    }
  }, [connection, navigate, user]);

  useEffect(() => {
    setCollapsed(!bp.md);
  }, [bp.md]);

  const changeLanguage = useCallback(
    (lng: any) => {
      i18n.changeLanguage(lng);
      localStorage.setItem('language', lng);
    },
    [i18n],
  );

  const menu = useMemo(() => {
    const menu: any[] = [];
    if (!user) {
      return [];
    }
    const has = (permission: any) => {
      return user?.permissions?.includes(permission);
    };
    menu.push({
      key: 'accounting',
      // icon: <CarryOutOutlined />,
      label: 'Accounting',
      children: [
        has(Permission.VIEW_SITES)
          ? {
              key: 'sites',
              // icon: <CarryOutOutlined />,
              label: 'Sites/SOLs',
              // roles: ['Manager', 'Supervisor', 'Employee'],
              onClick: () => navigate(`/webux/sites`),
            }
          : undefined,
        has(Permission.COA_VIEW)
          ? {
              key: 'chart-of-accounts',
              // icon: <CarryOutOutlined />,
              label: 'Chart of Accounts',
              // roles: ['Manager', 'Supervisor', 'Employee'],
              onClick: () => navigate(`/webux/chart-of-accounts`),
            }
          : undefined,
        has(Permission.COA_VIEW)
          ? {
              key: 'transactions',
              // icon: <CarryOutOutlined />,
              label: 'Transactions',
              // roles: ['Manager', 'Supervisor', 'Employee'],
              onClick: () => navigate(`/webux/transactions`),
            }
          : undefined,
        has(Permission.GL_VIEW)
          ? {
              key: 'general-ledger',
              // icon: <CarryOutOutlined />,
              label: 'General Ledger',
              // roles: ['Manager', 'Supervisor', 'Employee'],
              onClick: () => navigate(`/webux/general-ledger`),
            }
          : undefined,
        // {
        //   key: 'expenses',
        //   icon: <CarryOutOutlined />,
        //   label: 'Expenses',
        //   // roles: ['Manager', 'Supervisor', 'Employee'],
        //   onClick: () => navigate(`/webux/expenses`),
        // },
      ].filter((a) => !!a),
    });
    // menu.push({
    //   key: 'vowd',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Value of Work Done (VOWD)',
    //   // roles: ['Manager', 'Supervisor', 'Employee'],
    //   onClick: () => navigate(`/webux/under-construction`),
    // });
    // menu.push({
    //   key: 'profiles',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Profiles (CRM)',
    //   // roles: ['Manager', 'Supervisor', 'Employee'],
    //   onClick: () => navigate(`/webux/under-construction`),
    // });
    // menu.push({
    //   key: 'inventory',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Inventories (IMS)',
    //   children: [
    //     {
    //       key: 'items',
    //       // icon: <CarryOutOutlined />,
    //       label: 'Items',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/items`),
    //     },
    //     {
    //       key: 'warehouses',
    //       // icon: <CarryOutOutlined />,
    //       label: 'Warehouses',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/warehouses`),
    //     },
    //   ],
    // });

    // menu.push({
    //   key: 'purchases',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Purchases (Bills)',
    //   children: [
    //     // {
    //     //   key: 'vendors',
    //     //   // icon: <CarryOutOutlined />,
    //     //   label: 'Vendors',
    //     //   // roles: ['Manager', 'Supervisor', 'Employee'],
    //     //   onClick: () => navigate(`/webux/vendors`),
    //     // },
    //     {
    //       key: 'po',
    //       // icon: <CarryOutOutlined />,
    //       label: 'Purchase Order',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/under-construction`),
    //     },
    //     {
    //       key: 'billss',
    //       // icon: <CarryOutOutlined />,
    //       label: 'Bills',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/bills`),
    //     },
    //   ],
    // });
    // menu.push({
    //   key: 'sales',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Sales (Invoices)',
    //   children: [
    //     // {
    //     //   key: 'vendors',
    //     //   // icon: <CarryOutOutlined />,
    //     //   label: 'Vendors',
    //     //   // roles: ['Manager', 'Supervisor', 'Employee'],
    //     //   onClick: () => navigate(`/webux/vendors`),
    //     // },
    //     {
    //       key: 'invoices',
    //       // icon: <CarryOutOutlined />,
    //       label: 'Invoices',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/under-construction`),
    //     },
    //     {
    //       key: 'quotations',
    //       // icon: <CarryOutOutlined />,
    //       label: 'Quotations',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/under-construction`),
    //     },
    //   ],
    // });
    menu.push({
      key: 'expenses',
      // icon: <CarryOutOutlined />,
      label: 'Expenses',
      children: [
        // {
        //   key: 'vendors',
        //   // icon: <CarryOutOutlined />,
        //   label: 'Vendors',
        //   // roles: ['Manager', 'Supervisor', 'Employee'],
        //   onClick: () => navigate(`/webux/vendors`),
        // },
        has(Permission.EXPENSE_VIEW)
          ? {
              key: 'expenses-x',
              // icon: <CarryOutOutlined />,
              label: 'Expenses',
              // roles: ['Manager', 'Supervisor', 'Employee'],
              onClick: () => navigate(`/webux/expenses`),
            }
          : undefined,
        // {
        //   key: 'expenses-com',
        //   // icon: <CarryOutOutlined />,
        //   label: 'Expenses - COM/COS',
        //   // roles: ['Manager', 'Supervisor', 'Employee'],
        //   onClick: () => navigate(`/webux/under-construction`),
        // },
        // {
        //   key: 'expenses-pnl',
        //   // icon: <CarryOutOutlined />,
        //   label: 'Expenses - P&L',
        //   // roles: ['Manager', 'Supervisor', 'Employee'],
        //   onClick: () => navigate(`/webux/under-construction`),
        // },
      ].filter((a) => !!a),
    });
    menu.push({
      key: 'income',
      // icon: <CarryOutOutlined />,
      label: 'Income',
      children: [
        has(Permission.INCOME_VIEW)
          ? {
              key: 'income-temp',
              // icon: <CarryOutOutlined />,
              label: 'Income',
              // roles: ['Manager', 'Supervisor', 'Employee'],
              onClick: () => navigate(`/webux/incomes`),
            }
          : undefined,
        // {
        //   key: 'other-income-pnl',
        //   // icon: <CarryOutOutlined />,
        //   label: 'Other Income - P&L',
        //   // roles: ['Manager', 'Supervisor', 'Employee'],
        //   onClick: () => navigate(`/webux/under-construction`),
        // },
        // {
        //   key: 'other-income-eo',
        //   // icon: <CarryOutOutlined />,
        //   label: 'Other Income - Extra Ordinary',
        //   // roles: ['Manager', 'Supervisor', 'Employee'],
        //   onClick: () => navigate(`/webux/under-construction`),
        // },
      ].filter((a) => !!a),
    });

    // menu.push({
    //   key: 'fixed-assets',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Fixed Assets (FAR)',
    //   children: [
    //     {
    //       key: 'fixed-asset-registry',
    //       // icon: <CarryOutOutlined />,
    //       label: 'Fixed Asset Registry',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/under-construction`),
    //     },
    //     {
    //       key: 'fixed-asset-dep',
    //       // icon: <CarryOutOutlined />,
    //       label: 'Asset Impairment/Depreciation',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/under-construction`),
    //     },
    //     {
    //       key: 'leased-assets',
    //       // icon: <CarryOutOutlined />,
    //       label: 'Leased Assets',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/under-construction`),
    //     },
    //   ],
    // });
    //
    // menu.push({
    //   key: 'cash-book',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Cash Book',
    //   // roles: ['Manager', 'Supervisor', 'Employee'],
    //   onClick: () => navigate(`/webux/under-construction`),
    // });

    if (has(Permission.PETTYCASH_VIEW)) {
      menu.push({
        key: 'petty-cash',
        // icon: <CarryOutOutlined />,
        label: 'Petty Cash',
        // roles: ['Manager', 'Supervisor', 'Employee'],
        onClick: () => navigate(`/webux/petty-cash`),
      });
    }
    if (has(Permission.PETTYCASH_VIEW)) {
      menu.push({
        key: 'my-petty-cash',
        // icon: <CarryOutOutlined />,
        label: 'My Petty Cash',
        // roles: ['Manager', 'Supervisor', 'Employee'],
        onClick: () => navigate(`/webux/my-petty-cash`),
      });
    }
    // menu.push({
    //   key: 'construction-contracts',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Construction Contracts (PMS)',
    //   // roles: ['Manager', 'Supervisor', 'Employee'],
    //   onClick: () => navigate(`/webux/under-construction`),
    // });
    //
    // menu.push({
    //   key: 'payroll',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Pay Roll',
    //   // roles: ['Manager', 'Supervisor', 'Employee'],
    //   onClick: () => navigate(`/webux/under-construction`),
    // });
    //
    // menu.push({
    //   key: 'sales-taxes',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Tax Maintenance',
    //   // roles: ['Manager', 'Supervisor', 'Employee'],
    //   onClick: () => navigate(`/webux/sales-taxes`),
    // });
    // menu.push({
    //   key: 'email-templates',
    //   // icon: <MailOutlined />,
    //   label: 'Email Templates',
    //   // roles: ['Manager', 'Supervisor', 'Employee'],
    //   onClick: () => navigate(`/webux/email-templates`),
    // });
    // menu.push({
    //   key: 'reports',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Reports',
    //   // roles: ['Manager', 'Supervisor', 'Employee'],
    //   children: [
    //     {
    //       key: 'trial-balance',
    //       // icon: <CarryOutOutlined />,
    //       label: 'Trial Balance',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/reports/trial-balance`),
    //     },
    //     {
    //       key: 'pnl',
    //       // icon: <CarryOutOutlined />,
    //       label: 'Profit and Loss',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/reports/under-construction`),
    //     },
    //   ],
    // });
    if (has(Permission.VIEW_USERS)) {
      menu.push({
        key: 'user-mng',
        // icon: <CarryOutOutlined />,
        label: 'Users',
        children: [
          {
            key: 'users',
            icon: <UserOutlined />,
            label: 'Users',
            // roles: ['Manager', 'Supervisor', 'Employee'],
            onClick: () => navigate(`/webux/users`),
          },
          {
            key: 'user-groups',
            icon: <UserOutlined />,
            label: 'User Groups',
            // roles: ['Manager', 'Supervisor', 'Employee'],
            onClick: () => navigate(`/webux/user-groups`),
          },
        ],
      });
    }
    // menu.push({
    //   key: 'setting',
    //   // icon: <CarryOutOutlined />,
    //   label: 'Settings',
    //   children: [
    //     {
    //       key: 'incomes-types',
    //       icon: <UserOutlined />,
    //       label: 'Income Types',
    //       // roles: ['Manager', 'Supervisor', 'Employee'],
    //       onClick: () => navigate(`/webux/setting/incomes-types`),
    //     },
    //   ],
    // });
    return menu;
    // .filter((m) => m.roles.indexOf(user.role) !== -1)
    // .map((m) => ({
    //   ...m,
    //   children: m.children?.filter(
    //     (m: any) => m.roles.indexOf(user.role) !== -1,
    //   ),
    // }));
  }, [navigate, user]);

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <a
          onClick={() => {
            changePw.current?.open();
          }}
        >
          {'Change Password'}
        </a>
      ),
    },
    {
      key: '2',
      label: (
        <a
          onClick={() => {
            connection.logout();
            navigate('/login', { replace: true });
          }}
        >
          {t('logout')}
        </a>
      ),
    },
  ];
  return (
    <Layout className="h-screen">
      {!collapsed && !bp.md && (
        <div
          className="fixed inset-0 bg-black opacity-25 z-[9000] cursor-pointer"
          onClick={() => setCollapsed(true)}
        />
      )}
      <Sider
        style={
          !bp.md
            ? { position: 'fixed', left: 0, top: 0, bottom: 0, zIndex: 10000 }
            : undefined
        }
        collapsed={collapsed}
        trigger={null}
        width={300}
        breakpoint="lg"
        collapsedWidth={bp.md ? 80 : 0}
        onBreakpoint={(broken) => {
          console.log(broken);
        }}
        onCollapse={(collapsed, type) => {
          console.log(collapsed, type);
        }}
      >
        <div className="p-4 flex items-center justify-between">
          <div className="text-white font-bold text-3xl">
            <img
              src={collapsed ? '/logo-square.png' : '/logo.png'}
              className="w-full max-w-[200px] max-h-[48px]"
            />
          </div>
          {!bp.md && (
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: '16px',
                width: 64,
                height: 64,
                color: 'white',
              }}
            />
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['4']}
          items={menu}
        />
      </Sider>
      <Layout className="h-screen relative pt-[64px]">
        <div className="shadow flex items-center justify-center absolute left-0 top-0 right-0 z-[1000] px-4 h-[64px]">
          <div className="max-w-[1600px] w-full flex items-center justify-between">
            <div className="flex gap-2 items-center">
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{
                  fontSize: '16px',
                  width: 64,
                  height: 64,
                }}
              />
              <h2 className="text-2xl font-bold">{ctx.title}</h2>
            </div>
            <div className="flex gap-2 items-center">
              {/*<Select*/}
              {/*  className="w-[64px]"*/}
              {/*  value={i18n.language ?? 'fr_FR'}*/}
              {/*  onChange={(value) => changeLanguage(value)}*/}
              {/*>*/}
              {/*  <Select.Option value={'fr_FR'}>*/}
              {/*    <img src="https://purecatamphetamine.github.io/country-flag-icons/3x2/CH.svg" />*/}
              {/*  </Select.Option>*/}
              {/*  <Select.Option value={'en_US'}>*/}
              {/*    <img src="https://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg" />*/}
              {/*  </Select.Option>*/}
              {/*  <Select.Option value={'sv_SE'}>*/}
              {/*    <img src="https://purecatamphetamine.github.io/country-flag-icons/3x2/SE.svg" />*/}
              {/*  </Select.Option>*/}
              {/*  <Select.Option value={'si_LK'}>*/}
              {/*    <img src="https://purecatamphetamine.github.io/country-flag-icons/3x2/LK.svg" />*/}
              {/*  </Select.Option>*/}
              {/*</Select>*/}
              {/*{user && user?.businessId && businesses.length > 0 && (*/}
              {/*  <Select*/}
              {/*    variant="borderless"*/}
              {/*    suffixIcon={false}*/}
              {/*    options={businesses}*/}
              {/*    defaultValue={user?.businessId}*/}
              {/*  />*/}
              {/*)}*/}
              <Dropdown trigger={['click']} menu={{ items }}>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <div className="flex items-center gap-2 h-[60px]">
                    <UserAvatar user={user} />
                    {user?.firstName} {user?.lastName}
                  </div>
                </a>
              </Dropdown>
            </div>
          </div>
        </div>
        {/*<Header style={{ background: colorBgContainer }}>*/}
        {/*  <h2>{ctx.title}</h2>*/}
        {/*  <Dropdown trigger={['click']} menu={{ items }}>*/}
        {/*    <a*/}
        {/*      onClick={(e) => {*/}
        {/*        e.preventDefault();*/}
        {/*      }}>*/}
        {/*      <div className="flex items-center gap-2 h-[60px]">*/}
        {/*        <UserOutlined />*/}
        {/*        {user?.firstName}*/}
        {/*      </div>*/}
        {/*    </a>*/}
        {/*  </Dropdown>*/}
        {/*</Header>*/}
        <Content className="overflow-y-scroll min-h-fit">
          <div className="bg-white sm:p-4">
            <Outlet />
          </div>
        </Content>
      </Layout>
      <ChangePasswordModal ref={changePw} />
    </Layout>
  );
};
